let intlMessages = {};
let _defaultLocale = 'en';

const getMessage = (messages, id) => {
  return Object.prototype.hasOwnProperty.call(messages, id) ? messages[id] : '';
};

const getMessageValue = (locale, id) => {
  const messages = getMessages(locale);
  const defaultMessages = getMessages(_defaultLocale);

  return getMessage(messages, id) || getMessage(defaultMessages, id);
};

const getMessages = (locale) => {
  return Object.prototype.hasOwnProperty.call(intlMessages, locale) ? intlMessages[locale] : {};
};

const setMessages = (messages, defaultLocale = 'en') => {
  intlMessages = messages;
  _defaultLocale = defaultLocale;
};

export {
  getMessages,
  getMessageValue,
  setMessages
};
